// Data statis website — 100% statis, tanpa backend/API.
// Untuk mengganti konten: edit file ini (teks/pengaturan) dan ganti file gambar di /public/images/.

export const SETTINGS = {
  wa_number: "085181800085",
  phone: "085181800085",
  email: "",
  alamat: "Kabupaten Brebes",
  maps_url: "",
  jam_operasional: "24 Jam",
};

export const GALLERY = [
  { id: "g1", judul: "Truck Box — Mitsubishi Fuso Colt Diesel", foto: "/images/truck-box-side.jpg" },
  { id: "g2", judul: "Truck Box — tampak depan", foto: "/images/truck-box-front.jpg" },
  { id: "g3", judul: "Truck Pasir — Putra Bengawan Logistik", foto: "/images/truck-pasir-1.jpg" },
  { id: "g4", judul: "Truck Pasir — tampak belakang", foto: "/images/truck-pasir-2.jpg" },
  { id: "g5", judul: "Truck Air — Putra Bengawan Logistik", foto: "/images/truck-air-1.jpg" },
  { id: "g6", judul: "Truck Air — tampak belakang", foto: "/images/truck-air-2.jpg" },
  { id: "g7", judul: "Truck Pasir — pembongkaran muatan", foto: "/images/galeri-pasir-bongkar.jpg" },
  { id: "g8", judul: "Truck Kayu — muatan kayu", foto: "/images/galeri-kayu-merah.jpg" },
  { id: "g9", judul: "Truck Kayu — tampak depan", foto: "/images/galeri-merah-depan.jpg" },
];
